import React, {PureComponent} from 'react';

import LandingFreelance from './LandingFreelanceUniverse.jsx';

import header from './images/header-finance.png?size=600';

const metaDescription = "Opportunités en management de transition et interim management : Directeur Administratif " +
  "et Financier, contrôle de gestion, consolidation, comptabilité, trésorerie, etc.";

export default class LandingFreelanceFinance extends PureComponent {
  render() {
    return (
      <LandingFreelance
        headerImg={header.src}
        metaDescription={metaDescription}
        metaTitle="Missions pour professionnels de la Finance"
        sectorText="de la finance"
        universeCode="finance"
      />
    )
  }
}
